export default __webpack_public_path__ + "static/media/homePage_2scene.f8b10381.png";